import React, {useEffect, useState} from "react";
import {Box, Button, Checkbox, Modal, Typography} from "@mui/material";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";
import {SaleTypeDto, UpdateSaleTypesObjectDto} from "../../../../../../../dtos";
import styles from "./saleTypesSettings.module.scss";
import {makeStyles} from "@mui/styles";
import {saleTypesDropdownData} from "../../../../../../../globals/Contants";
import {SaleTypeSettingsRow} from "./saleTypeSettingsRow";
import {useDispatch} from "react-redux";
import {updateSaleTypeForAccount} from "../../../../../../../store/actionCreators/flyersActionCreators";
import {ClosePopupBtn} from "../../../../../../../com/closePopupBtn/closePopupBtn";

const useStyles = makeStyles(() => ({
    saleTypesPopupWrapper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: `50vw`,
        width: `45vw`,
        backgroundColor: `#ffffff`,
        display: "flex",
        flexFlow: "column",
        maxHeight: `90vh`,
        paddingBottom: `20px`
    },
    saleTypesPopupHeaderWrapper: {
        background: `linear-gradient(90deg, #1D95DE 0%, #00467F 100%)`,
    },
    saleTypesPopupHeaderBox: {
        display: `flex`,
        alignItems: `center`,
        justifyContent: `space-between`,
        padding: `6px 20px`,
        '& > .MuiButton-root': {
            '& svg path': {
                fill: `#ffffff`
            }
        }
    },
    saleTypesPopupContentWrapper: {
        flex: `1 1 auto`,
        overflow: "auto"
    },
    saleTypesPopupBtnWrapper: {
        display: `flex`,
        justifyContent: `end`,
        padding: `20px 20px 0`
    },

    saleTypesPopupBtn: {
        width: `100%`,
        background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
        '&.MuiButton-root': {
            padding: `10px 40px`,
        },
        '&.Mui-disabled': {
            opacity: `0.5`,
        },
        '& > .MuiTypography-root': {
            lineHeight: `15px`
        }
    },

}));


interface Props {
    isShow: boolean,
    onHide: VoidFunction;
}



export const SaleTypesSettings: React.FC<Props> = ({
    isShow,
    onHide
                                                   }) => {
    const dispatch = useDispatch();
    const saleTypes = useTypedSelector((state) => state.saleTypes.saleTypes);
    const classes = useStyles();
    const [saleTypesState, setSaleTypesState] = useState<SaleTypeDto[]>([]);
    const [isSelectAll, setSelectAllStatus] = useState<boolean>(false);
    const [numberOfSelectedSaleType, setNumberOfSelectedSaleTypes] = useState<number>(0)

    useEffect(() => {
        if(isShow){
            setSaleTypesState(saleTypes);
        }
    }, [isShow]);

    useEffect(() => {
        const isSelectedAllSaleTypes = saleTypesState.every((saleType: SaleTypeDto) => saleType.isAssignedToAccount);
        const selectedSaleTypes = saleTypesState.filter((saleType: SaleTypeDto) => {
            if(saleType.isAssignedToAccount){
                return saleType;
            }
        });
        setNumberOfSelectedSaleTypes(selectedSaleTypes.length);
        setSelectAllStatus(isSelectedAllSaleTypes);
    }, [saleTypesState])

    const onChangeSelectionForSaleType = (selectedSaleType: SaleTypeDto, isSelect: boolean) => {
        const newStateForSaleTypes = saleTypesState.map((saleType: SaleTypeDto) => {
            return {
                ...saleType,
                isAssignedToAccount: saleType.satRecID === selectedSaleType.satRecID ? isSelect : saleType.isAssignedToAccount
            };
        });
        setSaleTypesState(newStateForSaleTypes);
    }

    const onClose = () => {
        setSaleTypesState([]);
        onHide();

    }

    const selectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newStateForSaleTypes = saleTypesState.map((saleType: SaleTypeDto) => {
            return {
                ...saleType,
                isAssignedToAccount: e.target.checked
            };
        });
        setSaleTypesState(newStateForSaleTypes);
    }

    const updateSaleTypesForAccount = () => {
        const collectDataForRequest: UpdateSaleTypesObjectDto[] = [];
        saleTypesState.forEach((saleType: SaleTypeDto) => {
            collectDataForRequest.push({
                saleTypeId: saleType.satRecID,
                action: saleType.isAssignedToAccount ? 1 : 2
            })
        });
        dispatch(updateSaleTypeForAccount(saleTypesState, collectDataForRequest));
        onClose();
    }

    const saleTypeRows = saleTypesState.map((saleType: SaleTypeDto) => {
        const selectedPatternSaleType = saleTypesDropdownData.find((key) => key.saleTypeId === saleType.satCode);
        return <SaleTypeSettingsRow key={saleType.satRecID} saleType={saleType} defaultSaleType={selectedPatternSaleType} isSelected={saleType.isAssignedToAccount!} onChangeSelectionForSaleType={onChangeSelectionForSaleType}/>
    })

    return (
        <Modal open={isShow} sx={{zIndex: 5}}>
            <Box className={classes.saleTypesPopupWrapper}>
                <Box className={classes.saleTypesPopupHeaderWrapper}>
                    <Box className={classes.saleTypesPopupHeaderBox}>
                        <Box>
                            <Typography color={`white`} fontSize={`16px`} fontWeight={`900`} letterSpacing={`0.2px`}>
                                Promo Types Settings
                            </Typography>
                        </Box>
                        <ClosePopupBtn onClose={onClose}/>
                    </Box>
                </Box>
                <Box sx={{margin: `15px 20px`}}>
                    <Typography>
                        Select from the Promo Types below only the ones that your account uses.
                        {/*Only these {numberOfSelectedSaleType} will show in PromoType selection in "Edit Promotion"*/}
                    </Typography>
                    <Typography>
                        The selected Promo Types will show in Edit Promotion command.
                        {/*Only these {numberOfSelectedSaleType} will show in PromoType selection in "Edit Promotion"*/}
                    </Typography>
                </Box>

                <Box className={classes.saleTypesPopupContentWrapper}>
                    <table className={styles.sale_types_table}>
                        <thead className={styles.header_sale_types_popup}>
                        <tr>
                            <th>
                                <Box sx={{display: `flex`, width: `100%`}} alignItems={`center`} justifyContent={`center`}>
                                    <Checkbox disableRipple onChange={selectAll} checked={isSelectAll}/>
                                    <Typography >
                                        ({numberOfSelectedSaleType})
                                    </Typography>
                                </Box>
                            </th>
                            <th>Sticker</th>
                            <th>Promo Type Code</th>
                            <th>Promo Type Label</th>
                            <th>Requisite</th>
                            <th>Benefit</th>
                        </tr>
                        </thead>
                        <tbody className={styles.content_sale_types}>
                        {
                            saleTypeRows
                        }
                        </tbody>
                    </table>
                </Box>

                <Box className={classes.saleTypesPopupBtnWrapper}>
                    <Box>
                        <Button className={classes.saleTypesPopupBtn} onClick={updateSaleTypesForAccount}>
                            <Typography color={`#ffffff`}>
                                Save
                            </Typography>
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}